import { RefObject, useMemo, useRef } from "react";
import { useMeasure } from "react-use";
import { UseMeasureRef } from "react-use/lib/useMeasure";

export interface IUseBoundingClientRectRefs {
  boxRef: RefObject<HTMLDivElement> | null;
  containerRef: UseMeasureRef<HTMLDivElement> | null;
}

export type IUseBoundingClientRect = [IUseBoundingClientRectRefs, Omit<DOMRect, "toJSON">];

export function useBoundingClientRect(): IUseBoundingClientRect {
  const boxRef = useRef<HTMLDivElement>(null);
  const [containerRef, bound] = useMeasure<HTMLDivElement>();

  const boundingClientRect: DOMRect | undefined = useMemo(() => {
    return boxRef.current?.getBoundingClientRect();
  }, [bound, boxRef.current]);

  return [
    { boxRef, containerRef },
    {
      top: boundingClientRect?.top ?? 0,
      bottom: boundingClientRect?.bottom ?? 0,
      width: boundingClientRect?.width ?? 0,
      height: boundingClientRect?.height ?? 0,
      left: boundingClientRect?.left ?? 0,
      right: boundingClientRect?.right ?? 0,
      x: boundingClientRect?.x ?? 0,
      y: boundingClientRect?.y ?? 0,
    },
  ];
}
